import {VehicleTypeApiModel} from "../../api/models/vehicle-type.api-model";
import {AbstractDictionaryViewModel} from "./abstract-dictionary.view-model";

export class VehicleTypeViewModel extends AbstractDictionaryViewModel<VehicleTypeApiModel> {
  public code: string;
  constructor(protected apiModel: VehicleTypeApiModel) {
    super(apiModel);
    this.fromApiModel(apiModel);
  }

  fromApiModel(apiModel: VehicleTypeApiModel): VehicleTypeViewModel {
    super.fromApiModel(apiModel);
    this.code = apiModel.code;
    return this;
  }
}
